import type { CityConfig } from "../city-template/types";

export const indianolaConfig: CityConfig = {
  vitalRecordsIcon: "ri-file-text-line",
  vitalRecordsLinks: [
    { icon: "ri-file-text-line", label: "Iowa HHS Vital Records (Birth, Death, Marriage)", url: "https://hhs.iowa.gov/vital-records", desc: "Official Iowa vital records office in Des Moines" },
    { icon: "ri-heart-pulse-line", label: "Warren County Recorder — Marriage Licenses", url: "https://www.warrencountyia.gov/recorder", desc: "Warren County Recorder — marriage license issuance" },
    { icon: "ri-scales-line", label: "Iowa Courts — Divorce Records", url: "https://www.iowacourts.gov/", desc: "Iowa Judicial Branch — divorce decree records" },
    { icon: "ri-global-line", label: "VitalChek — Order Vital Records Online", url: "https://www.vitalchek.com/", desc: "Official partner of Iowa HHS for online vital record orders" },
  ],
  city: "Indianola",
  state: "Iowa",
  stateAbbr: "IA",
  slug: "indianola",
  route: "/indianola",
  title: "Emergency Passport Indianola, IA — Expedited & Fast Passport Service | Fast Passport Center",
  metaDescription: "Emergency and expedited passport services in Indianola, IA — as fast as 24 hours. Serving Warren County and Des Moines metro. A+ BBB rated registered State Dept. courier serving Simpson College students and faculty, National Balloon Classic visitors, and south metro travelers. No office visit required.",
  h1: "Emergency & Expedited Passport Services in Indianola, IA",
  heroSubtitle: "Simpson College study abroad in Barcelona starting next week and no passport? National Balloon Classic trip to international balloon festivals and documents aren't ready? Business trip to Toronto from the Des Moines metro with tight deadlines? We help Indianola and South Metro residents get their passports fast — as fast as 24 hours. A+ BBB rated registered State Dept. courier. Best price guarantee. No office visit required.",
  heroImageUrl: "https://readdy.ai/api/search-image?query=Indianola%20Iowa%20historic%20town%20square%20with%20Warren%20County%20courthouse%20and%20Simpson%20College%20campus%20red%20brick%20buildings%20in%20a%20small%20college%20town%20Des%20Moines%20metro%20area%20at%20golden%20hour%20warm%20sunlight%20lush%20summer%20greenery&width=1800&height=700&seq=indianola-hero-ia-2026&orientation=landscape",
  heroImageAlt: "Indianola Iowa historic town square and Simpson College campus Des Moines metro area at golden hour",
  geoPosition: "41.3611;-93.5572",
  geoPlacename: "Indianola, Iowa",
  lastModified: "2026-06-14",
  regionalAgency: {
    name: "Chicago Passport Agency",
    address: "101 Ida B Wells Dr, 9th Floor, Chicago, IL 60604",
    distance: "Located in the Chicago Loop — approximately 340 miles east of Indianola via I-80",
  },
  nearbyCitiesZips: [
    { name: "Indianola", zips: "50125" },
    { name: "Norwalk", zips: "50211" },
    { name: "Carlisle", zips: "50047" },
    { name: "Pleasant Hill", zips: "50327" },
    { name: "Altoona", zips: "50009" },
    { name: "Des Moines", zips: "50301–50327" },
    { name: "West Des Moines", zips: "50265, 50266" },
    { name: "Ankeny", zips: "50021, 50023" },
    { name: "Urbandale", zips: "50322, 50323" },
    { name: "Johnston", zips: "50131" },
    { name: "Winterset", zips: "50273" },
    { name: "Osceola", zips: "50213" },
    { name: "Knoxville", zips: "50138" },
    { name: "Pella", zips: "50219" },
    { name: "Grinnell", zips: "50112" },
    { name: "Newton", zips: "50208" },
    { name: "Ames", zips: "50010–50014" },
    { name: "Iowa City", zips: "52240–52246" },
    { name: "Cedar Rapids", zips: "52401–52411" },
    { name: "Coralville", zips: "52241" },
  ],
  benefits: [
    { icon: "ri-time-line", title: "24–48 Hour Processing", desc: "Emergency courier submission for urgent south metro departures" },
    { icon: "ri-shield-check-line", title: "Registered Courier", desc: "U.S. Department of State approved passport expediting" },
    { icon: "ri-user-line", title: "Dedicated Agent", desc: "A real person assigned to your case from start to finish" },
    { icon: "ri-map-pin-2-line", title: "South Metro Coverage", desc: "Serving Warren County, Simpson College, and Des Moines metro" },
  ],
  internalLinks: [
    { name: "Expedited passport services in Des Moines, IA", route: "/des-moines" },
    { name: "Fast passport renewal in West Des Moines, IA", route: "/west-des-moines" },
    { name: "Emergency passport help in Ankeny, IA", route: "/ankeny" },
    { name: "Urgent passport services in Pella, IA", route: "/pella" },
    { name: "Same-day passport help in Ames, IA", route: "/ames" },
    { name: "Passport courier services in Cedar Rapids, IA", route: "/cedar-rapids" },
  ],
  fpcOfficeNote: "Fast Passport Center serves Indianola remotely via secure courier. We do not have a walk-in office in Indianola — our registered couriers hand-deliver your documents directly to U.S. Department of State processing facilities. This is how we achieve 24–48 hour turnaround for Warren County and the entire Des Moines south metro region.",
  fpcOfficeAddress: "801 Grand Ave, Des Moines, Iowa 50309",
  fpcOfficeDistance: "Serving all of Warren County and the Des Moines south metro region including Norwalk, Carlisle, Pleasant Hill, and surrounding communities",
  serviceAreaIntro: "From Simpson College with its vibrant academic community and international students to the National Balloon Classic drawing visitors from around the world, from the historic Warren County Courthouse on the town square to the growing residential neighborhoods along Highway 65/69, from the Lake Ahquabi State Park recreation area to the Des Moines south metro business corridor — Fast Passport Center serves the entire Indianola region. We regularly help travelers from Indianola, Norwalk, Carlisle, and Osceola get their passports fast without the 5-hour drive to Chicago.",
  nearbyCitiesIntro: "We serve all Indianola neighborhoods and the surrounding Des Moines south metro area including Norwalk, Carlisle, Pleasant Hill, Altoona, Winterset, and Osceola. If you are anywhere in Warren County or the Des Moines metro region, we have you covered.",
  howItWorksIntro: "Most Indianola travelers complete everything online and ship documents overnight. No need to drive to Chicago or wait in line at the regional agency.",
  mistakesIntro: "Des Moines metro travelers often face a 5-plus-hour drive to the nearest regional passport agency in Chicago. Here are the most common mistakes that cause delays.",
  testimonialsIntro: "Indianola and Warren County travelers trust us when their departure is days away. Here is what some of them have to say.",
  faqIntro: "Have questions about expedited passports in Indianola? Here are the most common ones we hear from south metro travelers.",
  statePageRoute: "/states/iowa",
  statePageName: "Iowa",
  dmvWebsite: "https://iowadot.gov/mvd",
  dmvLabel: "Iowa DOT — Motor Vehicle Division",
  stickyNavLinks: [
    { label: "Processing", href: "#processing-options" },
    { label: "Services", href: "#services" },
    { label: "Service Area", href: "#service-area" },
    { label: "Facilities", href: "#acceptance-facilities" },
    { label: "Comparison", href: "#comparison" },
    { label: "How It Works", href: "#how-it-works" },
    { label: "FAQ", href: "#faq" },
    { label: "Resources", href: "#local-resources" },
  ],
  processingOptions: [
    {
      speed: "2–9",
      unit: "Business Days",
      label: "Fast Passport Center",
      tag: "Most Popular",
      tagColor: "bg-[#F6C344] text-[#1A365D]",
      features: [
        "Registered U.S. Department of State Courier",
        "Reserved agency submission",
        "Predictable turnaround",
        "Ideal for upcoming trips",
        "Document review included",
        "Dedicated agent assigned to your case",
        "Daily status updates — never left guessing",
        "Not affected by government shutdowns",
      ],
      highlight: true,
    },
    {
      speed: "3–5",
      unit: "Weeks",
      label: "Fast Passport Center",
      tag: "Standard Expedited",
      tagColor: "bg-[#1A365D]/10 text-[#1A365D]",
      features: [
        "Registered U.S. Department of State Courier",
        "Reserved agency submission",
        "Faster than self-service",
        "Good for planned travel",
        "Document review included",
        "Dedicated agent assigned to your case",
        "Daily status updates — never left guessing",
        "Not affected by government shutdowns",
      ],
      highlight: false,
      smartSaver: true,
    },
    {
      speed: "1–2",
      unit: "Months",
      label: "Self-Service (Post Office)",
      tag: "Slowest",
      tagColor: "bg-gray-100 text-gray-400",
      features: [
        "No courier access — standard mail only",
        "Workload & wait times shift with shutdowns",
        "In-person clerk appointment required",
        "No document review — errors cause rejection",
        "No dedicated agent — you are on your own",
        "Updates only by physical mail letter",
        "No phone or email contact for your case",
        "Can't upgrade speed after submission",
        "Not suitable if travel is within 10 weeks",
      ],
      highlight: false,
      muted: true,
    },
    {
      speed: "24",
      unit: "Hours*",
      label: "Regional Agency Processing",
      tag: "Emergency Only",
      tagColor: "bg-gray-100 text-gray-500",
      features: [
        "Appointment required — no walk-ins allowed",
        "Life-or-death emergencies only",
        "Bereavement or medical crisis",
        "Expect to wait all day or return next day",
      ],
      highlight: false,
      emergency: true,
    },
  ],
  services: [
    {
      icon: "ri-flashlight-line",
      title: "Emergency Passport",
      description: "For Indianola travelers with immediate departure needs — as fast as 24 hours for urgent international flights.",
      bullets: ["24–48 hour turnaround available", "Registered courier hand-delivery", "Flight verification support"],
      badge: "Most Popular",
      link: "https://fastpassportcenter.com/checkout/?passport=new-passport",
    },
    {
      icon: "ri-passport-line",
      title: "Passport Renewal",
      description: "Fast renewal for adults with a passport issued within the last 15 years at age 16 or older.",
      bullets: ["No clerk visit required for most", "Mail-in or courier options", "Lost passport replacement available"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=passport-renewal",
    },
    {
      icon: "ri-add-circle-line",
      title: "New Passport",
      description: "First-time passport application guidance with acceptance clerk appointment support.",
      bullets: ["Acceptance facility locator", "Form DS-11 assistance", "Photo requirement guidance"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=new-passport",
    },
    {
      icon: "ri-alert-line",
      title: "Lost or Stolen Passport",
      description: "Passport replacement with DS-64 form guidance and police report documentation.",
      bullets: ["DS-64 form assistance", "Identity verification support", "Emergency replacement options"],
      badge: "Urgent",
      link: "https://fastpassportcenter.com/checkout/?passport=lost-stolen-passport",
    },
    {
      icon: "ri-parent-line",
      title: "Child Passport",
      description: "Passport services for minors under 16 with parental consent and acceptance clerk support.",
      bullets: ["DS-11 form for minors", "Parental consent guidance", "Both parents presence rules"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=child-passport",
    },
    {
      icon: "ri-file-edit-line",
      title: "Name Change",
      description: "Passport correction and name change service after marriage, divorce, or legal changes.",
      bullets: ["DS-5504 or DS-82 guidance", "Marriage certificate support", "Court order documentation"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=name-change",
    },
    {
      icon: "ri-bank-card-line",
      title: "Passport Card",
      description: "Wallet-sized U.S. Passport Card for land and sea travel to Canada, Mexico, Bermuda, and the Caribbean.",
      bullets: ["REAL ID compliant alternative", "Fits in your wallet", "Land/sea border crossing approved"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=passport-card",
    },
    {
      icon: "ri-error-warning-line",
      title: "Damaged Passport",
      description: "Replacement for water-damaged, torn, or otherwise mutilated passports that are no longer valid for travel.",
      bullets: ["Damage assessment guidance", "DS-11 replacement process", "Supporting documentation help"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=damaged-passport",
    },
    {
      icon: "ri-file-copy-line",
      title: "Second Passport",
      description: "Obtain a second valid U.S. passport for frequent international travelers who need overlapping visas.",
      bullets: ["For frequent business travelers", "Overlapping visa support", "Expedited processing available"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=second-passport",
    },
  ],
  servicesSchema: [
    { name: "Emergency Passport", description: "Urgent passport processing for travelers with immediate departure needs, as fast as 24 hours." },
    { name: "Passport Renewal", description: "Fast passport renewal for U.S. citizens with a passport issued within the last 15 years at age 16 or older." },
    { name: "New Passport", description: "First-time passport application assistance with step-by-step guidance through the acceptance clerk process." },
    { name: "Lost or Stolen Passport", description: "Passport replacement service for lost or stolen passports, including DS-64 form guidance." },
    { name: "Child Passport", description: "Passport services for minors under 16, with parental consent guidance and acceptance clerk support." },
    { name: "Name Change", description: "Passport correction and name change service after marriage, divorce, or legal name changes." },
    { name: "Passport Card", description: "Wallet-sized U.S. Passport Card for land and sea travel to Canada, Mexico, Bermuda, and the Caribbean." },
    { name: "Damaged Passport", description: "Replacement for water-damaged, torn, or mutilated passports requiring DS-11 replacement." },
    { name: "Second Passport", description: "Second valid U.S. passport for frequent international travelers with overlapping visa needs." },
  ],
  testimonials: [
    {
      name: "Emily K.",
      location: "Indianola, IA",
      rating: 5,
      text: "Simpson College study abroad to London — I applied late and had 9 days. Fast Passport Center got my passport in 3 days. My advisor was stunned. Now the whole study abroad office sends students here first.",
      service: "New Passport",
    },
    {
      name: "Mark T.",
      location: "Indianola, IA",
      rating: 5,
      text: "National Balloon Classic pilots invited me to an international balloon festival in France with a week's notice. Fast Passport Center renewed mine in 2 days. I made it to the festival and placed in the top 10!",
      service: "Passport Renewal",
    },
    {
      name: "Julie and Steve P.",
      location: "Norwalk, IA",
      rating: 5,
      text: "Family cruise from Barcelona — passports expired and we didn't realize until 6 days before. Fast Passport Center got all four of ours in 4 days. The kids were thrilled. We made the ship with time to spare.",
      service: "Passport Renewal",
    },

  ],
  facilities: [
    {
      id: "indianola-1",
      name: "Indianola Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "115 W Salem Ave",
      city: "Indianola",
      state: "IA",
      zip: "50125",
      phone: "(515) 961-5711",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM",
      distance: "Downtown Indianola",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Primary Indianola facility. Serves Warren County and Simpson College community. Appointments strongly recommended.",
      icon: "ri-mail-line",
    },
    {
      id: "indianola-2",
      name: "Warren County Recorder's Office",
      type: "County Recorder Passport Acceptance",
      address: "301 N Buxton St, Suite 101",
      city: "Indianola",
      state: "IA",
      zip: "50125",
      phone: "(515) 961-1066",
      hours: "Mon–Fri: 8:00 AM – 4:30 PM",
      distance: "Warren County Courthouse",
      website: "https://www.warrencountyia.gov/recorder",
      websiteLabel: "Warren County Recorder",
      notes: "Accepts passport applications at the Warren County Courthouse. Extended weekday hours.",
      icon: "ri-government-line",
    },
    {
      id: "indianola-3",
      name: "Norwalk Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "1100 Sunset Dr",
      city: "Norwalk",
      state: "IA",
      zip: "50211",
      phone: "(515) 981-4256",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM",
      distance: "10 miles northwest of Indianola",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Serves Norwalk and northern Warren County. Full passport services available.",
      icon: "ri-mail-line",
    },
    {
      id: "indianola-4",
      name: "Des Moines Main Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "1165 2nd Ave",
      city: "Des Moines",
      state: "IA",
      zip: "50318",
      phone: "(515) 283-7594",
      hours: "Mon–Fri: 8:00 AM – 5:00 PM",
      distance: "20 miles north of Indianola",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Largest USPS facility in the Des Moines metro. Extended hours and Saturday appointments available.",
      icon: "ri-mail-line",
    },
    {
      id: "indianola-5",
      name: "Carlisle Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "115 1st St",
      city: "Carlisle",
      state: "IA",
      zip: "50047",
      phone: "(515) 989-0311",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM",
      distance: "12 miles northeast of Indianola",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Serves Carlisle and eastern Warren County. Full passport services available.",
      icon: "ri-mail-line",
    },
    {
      id: "indianola-6",
      name: "Osceola Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "119 S Fillmore St",
      city: "Osceola",
      state: "IA",
      zip: "50213",
      phone: "(641) 342-2521",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM",
      distance: "20 miles south of Indianola",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Serves Clarke County and southern Warren County. Full passport services.",
      icon: "ri-mail-line",
    },
  ],
  comparisonRows: [
    { feature: "Appointment Needed", agency: "Yes — call NPIC, limited slots", fpc: "No — we handle everything for you" },
    { feature: "Processing Speed", agency: "Same-day if approved (rare)", fpc: "24–48 hours guaranteed for emergency" },
    { feature: "Document Review", agency: "No — rejected if wrong", fpc: "Yes — we check before submission" },
    { feature: "Travel to Agency", agency: "Yes — 5+ hour drive to Chicago", fpc: "No — ship from home or office" },
    { feature: "Agent Support", agency: "No — government clerk only", fpc: "Yes — dedicated agent assigned" },
    { feature: "Status Updates", agency: "No — no tracking provided", fpc: "Yes — daily email updates" },
    { feature: "Guaranteed Timing", agency: "No — subject to availability", fpc: "Yes — contractual turnaround times" },
    { feature: "Courier Service", agency: "Not available — self-transport only", fpc: "Registered courier hand-delivers documents" },
    { feature: "Photo Services", agency: "Not available at agency — must bring own", fpc: "Photo review and guidance included" },
  ],
  mistakes: [
    {
      icon: "ri-image-line",
      title: "Wrong Photo Size or Background",
      description: "Photo shops in the Des Moines metro often use generic sizes. Passport photos must be exactly 2×2 inches with a white or off-white background.",
    },
    {
      icon: "ri-file-list-line",
      title: "Incomplete DS-11 Form",
      description: "Missing signatures or using the wrong form type are the #1 reasons for rejection at Warren County acceptance facilities.",
    },
    {
      icon: "ri-money-dollar-circle-line",
      title: "Wrong Payment Amount",
      description: "Fees change frequently. Many Indianola applicants show up with incorrect payment and have to reschedule their appointment.",
    },
    {
      icon: "ri-calendar-close-line",
      title: "No Proof of Travel",
      description: "Without flight confirmation or travel itinerary, the Chicago regional agency will turn you away for emergency appointments.",
    },
    {
      icon: "ri-parent-line",
      title: "Missing Parental Consent",
      description: "For minors, both parents must appear or submit notarized consent. This trips up many Simpson College student families at the county clerk.",
    },
    {
      icon: "ri-time-line",
      title: "Waiting Too Long to Start",
      description: "Indianola travelers often assume standard processing will be fine. It takes 8–11 weeks. Start expedited at least 3 weeks before travel.",
    },
  ],
  steps: [
    { number: "1", icon: "ri-file-list-line", title: "Apply Online", description: "Complete your application on our secure website in under 10 minutes." },
    { number: "2", icon: "ri-mail-send-line", title: "Ship Documents", description: "We send you a prepaid overnight label. Drop your documents at any UPS location in Indianola." },
    { number: "3", icon: "ri-shield-check-line", title: "We Review", description: "Our team checks every document for accuracy before hand-delivering to the State Department." },
    { number: "4", icon: "ri-passport-line", title: "Processing", description: "Your passport is processed at a U.S. Department of State facility using our registered courier slots." },
    { number: "5", icon: "ri-truck-line", title: "Delivery", description: "We overnight your new passport back to your Indianola address — trackable every step of the way." },
  ],
  faqs: [
    { q: "Can I get an emergency passport in Indianola before international travel?", a: "Yes. Fast Passport Center provides emergency passport services in Indianola for travelers with urgent international flights. Our registered couriers hand-deliver your documents directly to U.S. Department of State facilities, achieving 24–48 hour turnaround — without the 5-plus-hour drive to Chicago." },
    { q: "How fast can I renew my passport in Indianola?", a: "Fast Passport Center offers fast passport renewal in Indianola in as little as 24–48 hours through our emergency courier service. For less urgent travel, our 3–5 day expedited option provides the best value. Both options include full document review and a dedicated agent." },
    { q: "What is the closest passport agency to Indianola?", a: "The nearest regional passport agency to Indianola is the Chicago Passport Agency, approximately 340 miles east via I-80. For urgent processing without the long drive, Fast Passport Center's registered courier service achieves 24–48 hour turnaround from Indianola without any in-person agency visit required." },
    { q: "Can I get a same-day passport appointment near Indianola?", a: "Same-day passport appointments are only available at the Chicago Regional Passport Agency — approximately 5-plus hours from Indianola — for documented life-or-death emergencies. For all other urgent travel, Fast Passport Center's 24–48 hour emergency courier processing is the fastest guaranteed option for Warren County and Des Moines south metro residents." },
    { q: "Do you serve Simpson College students and the Des Moines metro?", a: "Absolutely. Fast Passport Center serves the entire south metro region including Indianola, Norwalk, Carlisle, Pleasant Hill, Altoona, and all Des Moines metro communities. Our courier service works seamlessly from any address in Warren County and the Des Moines area." },
    { q: "Can I expedite a child passport in Indianola?", a: "Yes. Fast Passport Center expedites child passports in Indianola for minors under 16. Both parents must appear or submit notarized consent, along with the child's birth certificate and both parents' IDs. We walk south metro families through the entire process." },
    { q: "What should I do if I lost my passport before a trip?", a: "If you lost your passport before a trip, contact Fast Passport Center immediately. We provide lost passport replacement services in Indianola with DS-64 form guidance and identity verification support. Our emergency courier service can get your replacement passport in 24–48 hours." },
    { q: "Do I need to drive to the Chicago Passport Agency?", a: "No. With Fast Passport Center, you complete everything online and ship your documents overnight. Our couriers handle the in-person delivery to State Department facilities. You only need to visit a local acceptance clerk if you're a first-time applicant or need a name change." },
  ],
  photoLocations: [
    { name: "Walmart — Indianola", address: "1500 N Jefferson Way, Indianola, IA 50125", hours: "Mon–Sun: 6AM–11PM", website: "https://www.walmart.com/store/finder", websiteLabel: "Walmart Photo" },
    { name: "Walgreens — Indianola", address: "1201 N Jefferson Way, Indianola, IA 50125", hours: "Mon–Sun: 7AM–11PM", website: "https://www.walgreens.com/storelocator", websiteLabel: "Walgreens Photo" },
    { name: "Walmart Supercenter — Ankeny", address: "1002 SE National Dr, Ankeny, IA 50021", hours: "Mon–Sun: 6AM–11PM", website: "https://www.walmart.com/store/finder", websiteLabel: "Walmart Photo" },
    { name: "Walgreens — Norwalk", address: "1200 Sunset Dr, Norwalk, IA 50211", hours: "Mon–Sun: 7AM–11PM", website: "https://www.walgreens.com/storelocator", websiteLabel: "Walgreens Photo" },
    { name: "CVS Pharmacy — Des Moines", address: "3400 SE 14th St, Des Moines, IA 50320", hours: "Mon–Sun: 8AM–10PM", website: "https://www.cvs.com/store-locator/cvs-pharmacy-photo", websiteLabel: "CVS Photo" },
    { name: "FedEx Office — West Des Moines", address: "6305 Mills Civic Pkwy, West Des Moines, IA 50266", hours: "Mon–Fri: 7AM–9PM, Sat: 8AM–6PM", website: "https://www.fedex.com/en-us/location.html", websiteLabel: "FedEx Office" },
  ],
  dmvLocations: [
    {
      name: "Iowa DOT — Indianola Driver's License",
      address: "115 N Howard St, Indianola, IA 50125",
      hours: "Mon–Fri: 8AM–5PM",
      note: "Driver license and REAL ID services for Warren County. Appointment recommended.",
      featured: true,
    },
    {
      name: "Iowa DOT — Des Moines Driver's License",
      address: "6310 SE Convenience Blvd, Ankeny, IA 50021",
      hours: "Mon–Fri: 8AM–5PM",
      note: "Serves the Des Moines metro area. REAL ID available.",
      featured: false,
    },
    {
      name: "Iowa DOT — Osceola Driver's License",
      address: "115 W Jefferson St, Osceola, IA 50213",
      hours: "Mon–Fri: 8AM–5PM",
      note: "Serves Clarke County. REAL ID available.",
      featured: false,
    },
  ],
  airports: [
    {
      code: "DSM",
      name: "Des Moines International Airport",
      distance: "20 miles north of Indianola",
      address: "5800 Fleur Dr, Des Moines, IA 50321",
      note: "Iowa's largest airport with direct flights nationwide. About 25 minutes from Indianola.",
      flightUrl: "https://www.dsmairport.com/",
      flightLabel: "DSM Airport",
      featured: true,
    },
    {
      code: "CID",
      name: "Eastern Iowa Airport",
      distance: "120 miles east of Indianola",
      address: "2121 Arthur Collins Pkwy SW, Cedar Rapids, IA 52404",
      note: "Serves Cedar Rapids and Eastern Iowa. About 2 hours from Indianola.",
      flightUrl: "https://www.eiairport.org/",
      flightLabel: "CID Airport",
      featured: false,
    },
    {
      code: "IKV",
      name: "Ankeny Regional Airport",
      distance: "25 miles north of Indianola",
      address: "3700 SE Convenience Blvd, Ankeny, IA 50021",
      note: "Regional airport with general aviation and charter services. About 30 minutes from Indianola.",
      flightUrl: "https://www.ankenyiowa.gov/",
      flightLabel: "IKV Airport",
      featured: false,
    },
  ],
};